import React, { useContext, useEffect, useState } from 'react';
import MemberIdentityCard from './MemberIdentityCard';
import './CardStudio.css';
import baseUrl from "../../../../BaseURL";
import { ContextData } from '../../../../context/Context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';

export default function PreCardShow(props) {


  const {Refresh,setRefresh, ID_ref_Num,setID_ref_Num ,accesstoken,issuance,setissuance,Dep_and_post,setDep_and_post} = useContext(ContextData);

  const {
    fname,
    lname,
    gender,
    age,
    position,
    department,
    stateoforigin,
    picture,
    r_ID,
    id_ref_num
  } = props.profileData;
  const [doneBTN,setdoneBTN] = useState(true)


   const HandleIDNum = (e)=>{
    setID_ref_Num(e.target.value)
}


   const HandleIDIssue = (e)=>{
        setissuance((prevData) => ({...prevData,[e.target.name]:e.target.value}))
   }


   const HandleDep_Post =  (e)=>{

    setDep_and_post((prevData) => ({...prevData,[e.target.name]:e.target.value}))
}


useEffect(()=>{

   setDep_and_post((prev) =>({...prev,department:department}))
   setDep_and_post((prev) =>({...prev,position:position}))
   setID_ref_Num("")

},[props.profileData])




const ProcessDoneIDCard = async () => {


     if(doneBTN === true) return toast.warn("You are not done with ID card while Reference number is empty, please fill the Reference number and click on update button")



  const fetchProfileData = async () => {

    try {
      const response = await axios.put(`${baseUrl}/auth/approve_id_card/${r_ID}`, {
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`
        }
      });


       if(response.data.status === true){

         toast.success(response.data.statusText);


         setRefresh(!Refresh)

       }else{

         toast.success(response.data.statusText);

        }



    } catch (error) {

      toast.warn("Error fetching profile data");
    }
  };

  fetchProfileData();



}



const HandleUpdateInputs = (type)=>{


  if(type === "dept"){


    const data = {
      value: Dep_and_post.department,
      r_ID,
      type:'dept'
                 }


 axios.put(`${baseUrl}/auth/update_card_inputs`,data,{
   withCredentials: true,
   headers: {
     'Accept' : 'application/json',
     'authorization': `Bearer ${accesstoken !== null && accesstoken}`

   }}).then(res=>{

    toast.success(res.data.statusText)

   }).catch(err=> {

       if(err) return toast.warn(err.message)

   })



  }else if(type === "post"){



    const data = {
      value: Dep_and_post.position,
      r_ID,
      type:'post'
                 }


 axios.put(`${baseUrl}/auth/update_card_inputs`,data,{
   withCredentials: true,
   headers: {
     'Accept' : 'application/json',
     'authorization': `Bearer ${accesstoken !== null && accesstoken}`

   }}).then(res=>{

    toast.success(res.data.statusText)

   }).catch(err=> {

       if(err) return toast.warn(err.message)

   })

  }else if(type === "idRefnum"){

    const data = {
      value : ID_ref_Num,
      r_ID,
      type:'idRefnum'
 }


 axios.put(`${baseUrl}/auth/update_card_inputs`,data,{
   withCredentials: true,
   headers: {
     'Accept' : 'application/json',
     'authorization': `Bearer ${accesstoken !== null && accesstoken}`

   }}).then(res=>{


        toast.success(res.data.statusText)
        setdoneBTN(false)

   }).catch(err=> {
    setdoneBTN(false)
       if(err) return toast.warn(err.message)

   })


  }










}




  return (
    <div className="fin-card-studio fin-single-studio">
      <section className="fin-card-preview" aria-label="Live card preview">
        <div className="fin-card-section-heading hide-at-prnt"><div><p className="fin-studio-eyebrow">CARD PREVIEW</p><h3>Membership identity</h3></div><span className="fin-card-tag">Front · CR80</span></div>
        <MemberIdentityCard data={{ ...props.profileData, department: Dep_and_post.department, position: Dep_and_post.position }} stateOfIssue={issuance.state} dateOfIssu={issuance.issuDate} dateOfExpiry={issuance.expiry} ID_ref_Num={`${ID_ref_Num || id_ref_num || ''}${r_ID || ''}`} />
        <p className="fin-card-preview-note hide-at-prnt">Live preview · Changes appear as you type. Save updated member details before completing the card.</p>
      </section>
      <section className="fin-card-editor hide-at-prnt" aria-label="Card details editor">
        <div className="fin-card-section-heading"><div><p className="fin-studio-eyebrow">CARD DETAILS</p><h3>Review & prepare</h3></div><Button onClick={() => ProcessDoneIDCard()} variant="contained">Mark done</Button></div>
        <div className="fin-card-readonly"><strong>{fname} {lname}</strong><span>{gender || '—'} · Age {age || '—'} · {stateoforigin || '—'}</span></div>
        <fieldset className="fin-card-fieldset"><legend>Organisation details</legend>
          <div className="fin-card-field"><label htmlFor={`position-${r_ID}`}>Position</label><div><input id={`position-${r_ID}`} name="position" value={Dep_and_post.position || ''} onChange={HandleDep_Post} /><Button onClick={() => HandleUpdateInputs('post')} variant="outlined">Save</Button></div></div>
          <div className="fin-card-field"><label htmlFor={`department-${r_ID}`}>Department</label><div><input id={`department-${r_ID}`} name="department" value={Dep_and_post.department || ''} onChange={HandleDep_Post} /><Button onClick={() => HandleUpdateInputs('dept')} variant="outlined">Save</Button></div></div>
        </fieldset>
        <fieldset className="fin-card-fieldset"><legend>Membership number</legend><p className="fin-card-help">Update the reference prefix using the existing membership numbering system.</p>
          <div className="fin-card-field"><label htmlFor={`reference-${r_ID}`}>Reference prefix</label><div><input id={`reference-${r_ID}`} value={ID_ref_Num} onChange={HandleIDNum} placeholder={id_ref_num || 'Enter prefix'} /><Button onClick={() => HandleUpdateInputs('idRefnum')} variant="outlined">Save</Button></div></div>
          <p className="fin-card-number-preview">FIN/{ID_ref_Num || id_ref_num}{r_ID}</p>
        </fieldset>
        <fieldset className="fin-card-fieldset"><legend>Issuance details</legend><div className="fin-card-issuance-grid">
          {[['state', 'State of issue'], ['issuDate', 'Date of issue'], ['expiry', 'Expiry date']].map(([key, label]) => <div className="fin-card-field" key={key}><label htmlFor={`${key}-${r_ID}`}>{label}</label><input id={`${key}-${r_ID}`} name={key} value={issuance[key]} onChange={HandleIDIssue} /></div>)}
        </div></fieldset>
      </section>
    </div>
  );
}
